import Vue from 'vue';
import Router from 'vue-router';
// import Home from './views/Home.vue';
import addScore from '@/components/InserisciPunteggio.vue';
import callback from '@/components/Callback.vue';
import prizeDetail from '@/components/PrizeDetail.vue';
import prizesList from '@/components/PrizesList.vue';
import userDetail from '@/components/UserDetail.vue';
import usersList from '@/components/UserList.vue';



Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Home,
    // },
    {
      path: '/',
      name: 'addScore',
      component: addScore,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/listapremi',
      name: 'prizesList',
      component: prizesList,
    },
    {
      path: '/premio/:id/',
      name: 'prizeDetail',
      component: prizeDetail,
    },
    {
      path: '/listautenti',
      name: 'usersList',
      component: usersList,
    },
    {
      path: '/utente/:id/',
      name: 'userDetail',
      component: userDetail,
    },
    {
      path: '/static/callback',
      name: 'callback',
      component: callback,
    },
  ],
});
